import { usernameFromGitLabUrl } from '~/common/LinkUtils';

import legacyTotals from './legacy/totals';

const LEGACY_YEAR_RE = /top_contributors_(\d{4})\.js$/;

const unwrap = module => module.default || module;

const totalsByYear = Object.fromEntries(
  legacyTotals.map(total => [total.year, total]),
);

const legacyFiles = import.meta.glob(
  './legacy/top_contributors_*.js',
  { eager: true },
);

const legacyYears = Object.entries(legacyFiles).map(([path, loaded]) => {
  const year = Number(path.match(LEGACY_YEAR_RE)[1]);
  const totals = totalsByYear[year] || {};

  return {
    year,
    type: 'legacy',
    totalContributors: totals.total_contributors ?? null,
    totalMergedMRs: totals.total_merged_mrs ?? null,
    contributors: unwrap(loaded).map(contributor => ({
      name: contributor.name,
      gitlabUrl: contributor.gitlab,
      username: usernameFromGitLabUrl(contributor.gitlab),
      mergedMRs: contributor.merged_mrs,
      category: contributor.category,
    })),
  };
});

const currentFiles = import.meta.glob(
  './top_contributors_*.js',
  { eager: true },
);

const currentYears = Object.values(currentFiles).map((loaded) => {
  const data = unwrap(loaded);

  return {
    year: data.year,
    type: 'current',
    generatedAt: data.generated_at,
    fromDate: data.from_date,
    toDate: data.to_date,
    totalContributors: data.total_contributors,
    totalMergedMRs: data.total_merged_mrs,
    contributors: data.contributors,
  };
});

export default [...legacyYears, ...currentYears].sort((a, b) => b.year - a.year);
